import { Injectable } from '@angular/core';
import { Country } from '../domain/ot-event';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { plainToClass } from 'class-transformer';

@Injectable({
  providedIn: 'root'
})
export class CountryService {

  private static countryPath = '/country';
  private countryUrl: string;

  constructor(private httpClient: HttpClient) {
    this.countryUrl = environment.publicApiUrl + CountryService.countryPath;
  }

  public async findAll(): Promise<Country[]> {
    const plainObject = await this.httpClient.get(this.countryUrl).toPromise();
    return plainToClass(Country, (plainObject as Object[]));
  }
}
